module.exports = __webpack_public_path__ + "assets/tenBis-logo-md-0c1146.svg";